import { render, staticRenderFns } from "./EmployeeViewModal.vue?vue&type=template&id=65654f63&scoped=true&"
import script from "./EmployeeViewModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeViewModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeViewModal.vue?vue&type=style&index=0&id=65654f63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65654f63",
  null
  
)

export default component.exports